import type { User } from './userType';
import { del, get, post, put } from '../request';

export async function isValidApi(username: string) {
  const result = await post<{
    isValid: number;
  }>('/user/valid/', {
    username,
  });
  return result.data;
}

export async function loginApi(username: string, password: string) {
  const result = await post<{
    token: string;
    refreshToken: string;
    user: User;
  }>('/auth/login/', {
    username,
    password,
  });
  return result.data;
}

export async function sendCodeApi(phone: string) {
  const result = await post<{ message: string }>('/auth/register/send-code/', { phone });
  return result.data;
}

export async function signupApi(
  username: string,
  password: string,
  realName: string,
  gender: number,
  email: string,
  phone: string,
  major: string,
  school: string,
  verificationCode?: string,
) {
  const body: Record<string, any> = { username, password, realName, gender, email, phone, major, school };
  if (verificationCode)
    body.verificationCode = verificationCode;
  const result = await post<{ user: User }>('/auth/register/', body);
  return result.data;
}

export async function fetchUserApi() {
  const result = await get<{
    user: User;
  }>('/user/');
  return result.data;
}

export async function completeProfileApi(profile: {
  realName?: string;
  college?: string;
  grade?: string;
  major?: string;
  studentId?: string;
  phone: string;
}) {
  const result = await put<{ user: User }>('/user/', profile);
  return result.data;
}

export async function putUserApi(
  realName: string,
  gender: number,
  email: string,
  phone: string,
  major: string,
  school: string,
  profile: { college?: string; grade?: string; studentId?: string } = {},
) {
  const body: Record<string, any> = { realName, gender, major, school, ...profile };
  if (email !== undefined)
    body.email = email;
  if (phone !== undefined)
    body.phone = phone;
  const result = await put<{
    user: User;
  }>('/user/', body);
  return result.data;
}

export async function updatePasswordApi(
  oldPassword: string,
  newPassword: string,
) {
  const result = await put<{
    user: User;
  }>('/user/password/', {
    oldPassword,
    newPassword,
  });
  return result.data;
}

export async function putUserAvatarApi(avatar: File) {
  const formData = new FormData();
  formData.append('avatar', avatar);
  const result = await put<{
    user: User;
  }>('/user/avatar/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return result.data;
}

export async function casValidateApi(ticket: string) {
  const response = await get<{
    user: User;
    token: string;
    refreshToken: string;
    requiresWechatBinding?: boolean;
  }>(`/user/validate/?ticket=${ticket}`);
  return response.data;
}

export async function wechatCallbackApi(code: string, mode: 'login' | 'bind') {
  const endpoint = mode === 'bind' ? '/auth/wechat/bind/' : '/auth/wechat/login/';
  const response = await post<{
    user?: User;
    token?: string;
    refreshToken?: string;
    bound?: boolean;
  }>(endpoint, {
    code,
  });
  return response.data;
}

export async function imathbookSsoExchangeApi(ticket: string) {
  const response = await post<{
    user: User;
    token: string;
    refreshToken: string;
    target: string;
  }>('/auth/imathbook/sso/', {
    ticket,
  });
  return response.data;
}

export async function startImathbookSsoApi(target: string) {
  const response = await post<{
    redirectUrl: string;
  }>('/auth/imathbook/sso/start/', {
    target,
  });
  return response.data;
}

export async function unbindWechatApi() {
  const response = await del<{
    user?: Partial<User>;
  }>('/auth/wechat/bind/');
  return response.data;
}

export async function bindWechatExistingApi(username: string, password: string) {
  const response = await post<{
    token: string;
    refreshToken: string;
    user: User;
  }>('/auth/wechat/bind-existing/', {
    username,
    password,
  });
  return response.data;
}

export async function bindWechatCasApi(ticket: string) {
  const response = await post<{
    token: string;
    refreshToken: string;
    user: User;
  }>('/auth/wechat/bind-cas/', {
    ticket,
  });
  return response.data;
}
